'use client'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from 'next/image'
import Link from 'next/link'

export default function NotFound() {
    return (
        <div className="flex flex-col gap-12 2xl:px-[500px] px-[300px] py-[100px] max-lg:px-8 max-md:flex-col items-center justify-center ">
            <Image
                src="/assets/icons/glofi_hand_orange.svg"
                height={222}
                width={200}
                alt=""
                className="max-md:absolute max-md:-left-1 max-md:rotate-90 max-md:w-[80px] mb-4"
            />
            <div className="flex flex-col gap-6">
                <p className=" text-4xl font-semibold text-black max-md:text-xl max-md:text-center">
                    404 - Página não encontrada
                </p>
                <p className="max-md:ml-8 max-md:text-center max-md:text-sm max-md:bg-cta-yellow max-md:border-[1.5px] max-md:border-dark-yellow max-md:rounded-full max-md:p-3">
                    A página que você acessou, não existe ou encontra-se indisponível
                </p>
            </div>
            <Link
                href="/"
                className="uppercase text-lg max-md:text-sm text-orange flex gap-2 hover:underline items-center"
            >
                <FontAwesomeIcon icon={faArrowUp} className=" max-md:-rotate-90" />
                Voltar para a página inicial
            </Link>
        </div>
    )
}
